// extracted by mini-css-extract-plugin
export default {"root":"style-module__root___KD4DW","root__block":"style-module__root__block___N97R9","root__title":"style-module__root__title___x7Tfl"};
    if(module.hot) {
      // 1729151132161
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  